// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1LYd0","noInteraction":"EventWrapper_noInteraction__2C42w","pointerPassthrough":"EventWrapper_pointerPassthrough__5CCGM"};